/// <amd-module name="TFS/Msal/TfsMsalInteractiveService" />

import { Services, VssService } from "VSS/Platform/Context";
import { IVssContributionService } from "VSS/Platform/Contribution";
import { ITfsMsalInteractiveService } from "./TfsMsalInteractiveService.types";
import { ITokenProviderService } from "VSS/Platform/TokenProvider";

interface SignOutConfiguration {
    signOutUrl: string;
}

class TfsMsalInteractiveService extends VssService implements ITfsMsalInteractiveService {
    public signOut(queryParameters?: URLSearchParams): Promise<void> {
        const contributionService = this.pageContext.getService<IVssContributionService>("IVssContributionService");
        const signOutConfiguration = contributionService.getData<SignOutConfiguration>("ms.vss-tfs-web.tfs-signout-url-data-provider");

        const tokenService = this.pageContext.getService<ITokenProviderService>("ITokenProviderService");
        return tokenService.logout().finally(() => {
            if (signOutConfiguration?.signOutUrl) {
                const signoutUrl = new URL(signOutConfiguration.signOutUrl, window.location.href);
                if (queryParameters) {
                    queryParameters.forEach((value, key) => {
                        signoutUrl.searchParams.set(key, value);
                    });
                }

                window.location.href = signoutUrl.href;
            }
        });
    }
}

Services.add("ITfsMsalInteractiveService", { serviceFactory: TfsMsalInteractiveService });
